import Api from './Api';

export const BIRTHDAY_ATTR_ID = 1;
export const SUBSCRIBE_SMS_ATTR_ID = 13;
export const SUBSCRIBE_EMAIL_ATTR_ID = 14;

export const User = {
  save: (userId, params) => Api.post(`/v1/user/users/${userId}`, params),
  uploadAvatar: (userId, params) => Api.post(`/v1/user/users/${userId}/avatar`, params),
  deleteAvatar: userId => Api.delete(`/v1/user/users/${userId}/avatar`),
};
